import React, { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Row, Col } from "antd";
import { FaHeart } from "react-icons/fa";

import Img from "../../assets/women-5.png";
import men1 from "../../assets/men-1.png";
import men2 from "../../assets/men-2.png";
import men3 from "../../assets/men-3.png";
import men4 from "../../assets/men-4.png";
import men5 from "../../assets/men-5.png";

import women1 from "../../assets/women-1.png";
import women2 from "../../assets/women-2.png";
import women3 from "../../assets/women-3.png";
import women4 from "../../assets/women-4.png";
import women5 from "../../assets/women-5.png";

import unisex1 from "../../assets/unisex-1.png";
import unisex2 from "../../assets/unisex-2.png";
import unisex3 from "../../assets/unisex-3.png";
import unisex4 from "../../assets/unisex-4.png";
import unisex5 from "../../assets/unisex-5.png";
import { server } from "../../utilis/constant";
import { useNavigate } from "react-router-dom";
import { addToWishlistAPI } from "../../redux/store/wishlist";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addToCart } from "../../redux/store/cartSlice";
import CartDrawer from "../CartDrawer";
import WishlistButton from "../WishlistButton";
import { useAuth } from "../../contexts/AuthContext";

gsap.registerPlugin(ScrollTrigger);

const Fragrances = ({ title, products }) => {
  const [activeTab, setActiveTab] = useState("New Arrivals");
  const titleRef = useRef(null);
  const [cartDrawer, setCartDrawer] = useState(false);
  const gridRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const tabs = [
    { id: 1, title: "New Arrivals" },
    { id: 2, title: "Best Sales" },
    { id: 3, title: "Featured" },
  ];

  // Filter products based on active tab
  const filteredProducts = products?.filter((product) =>
    product.tags.some((tag) =>
      tag.toLowerCase().includes(activeTab.toLowerCase()),
    ),
  );

  // GSAP Title Animation
  useEffect(() => {
    gsap.from(titleRef.current, {
      y: -60,
      opacity: 0,
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: { trigger: titleRef.current, start: "top 85%" },
    });
  }, []);

  // GSAP Cards Animation when tab changes
  useEffect(() => {
    if (!gridRef.current) return;
    const cards = gridRef.current.querySelectorAll(".product-card");

    gsap.fromTo(
      cards,
      { opacity: 0, y: 80, scale: 0.92 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        stagger: 0.06,
        ease: "power3.out",
      },
    );
  }, [filteredProducts]);

  const { isLoggedIn } = useSelector((state) => state.user);
  const { openLoginModal } = useAuth();

  const handleWishlist = async (product) => {
    if (!isLoggedIn) {
      openLoginModal();
      return;
    }

    try {
      await dispatch(addToWishlistAPI(product._id)).unwrap();
      toast.success("Added to wishlist");
    } catch (error) {
      console.error('Wishlist error:', error);
      if (error.includes('Access denied') || error.includes('authentication token')) {
        // Token might be invalid, show login modal
        openLoginModal();
      } else if (error.includes('already in wishlist')) {
        toast.error("Already in wishlist");
      } else {
        toast.error(error || "Failed to add to wishlist");
      }
    }
  };

  const handleAddtoCart = (product) => {
    dispatch(addToCart(product));
    toast.success("Add to Cart Successfully");
    setCartDrawer(true);
  };

  return (
    <section className="fragrances py-12 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        {/* Title */}
        <h1
          ref={titleRef}
          className="text-center text-[clamp(2.2rem,9vw,3.8rem)] leading-tight font-bold tracking-tight text-black mb-8 sm:mb-14 product-tabs"
        >
          {title}
        </h1>

        {/* Tabs */}
        <div className="flex justify-start sm:justify-center overflow-x-auto hide-scrollbar gap-3 sm:gap-4 mb-10 sm:mb-14 px-1 pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.title)}
              className={`px-6 sm:px-9 py-3.5 sm:py-4 rounded-full text-sm font-medium transition-all border-2 duration-300 whitespace-nowrap flex-shrink-0
                ${
                  activeTab === tab.title
                    ? "bg-black text-white border-black shadow-lg"
                    : "border-black text-black hover:bg-black hover:text-white"
                }`}
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Products Grid - 4 per row (xl=6) */}
        <div ref={gridRef}>
          <Row gutter={[28, 36]} align="stretch">
            {filteredProducts?.slice(0, 8)?.map((product) => (
              <Col key={product._id} xs={24} sm={12} lg={8} xl={6}>
                <div className="product-card group h-full bg-white rounded-3xl border border-gray-200 hover:shadow-2xl hover:-translate-y-3 transition-all duration-500 flex flex-col relative">
                  {/* Image Section */}
                  <div className="relative aspect-[4/3.2] bg-[#F8F4ED] ">
                    <img
                      onClick={() =>
                        navigate(`/product_description/${product._id}`)
                      }
                      src={`${server}/${product.image || product.variants?.[0]?.image}`}
                      alt={product.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />

                    {/* New Badge */}
                    {product.tags.includes("New Arrivals") && (
                      <div className="absolute top-5 left-5 bg-gradient-to-br from-[#D4AF37] to-[#B8972E] text-black text-xs font-bold px-5 py-1.5 rounded-full shadow-md">
                        NEW
                      </div>
                    )}

                    {/* Wishlist Button */}
                    <div className="absolute top-5 right-5">
                      <WishlistButton product={product} size="sm" />
                    </div>
                  </div>

                  {/* Content - Tight Spacing */}
                  <div className="px-6 pt-5 pb-6 flex flex-col flex-1 text-center">
                    <h3 className="font-semibold text-lg leading-tight text-black line-clamp-2 mb-3 min-h-[52px]">
                      {product.title}
                    </h3>

                    <div className="flex justify-center gap-1 text-[#D4AF37] text-2xl mb-4">
                      {"★".repeat(Math.floor(product.rating || 4))}
                      {"☆".repeat(5 - Math.floor(product.rating || 4))}
                    </div>

                    {/* Price + Add to Cart */}
                    <div className="mt-auto flex items-center justify-between">
                      <p className="text-3xl font-bold text-black tracking-tight">
                        ${product.variants[0].price}
                      </p>

                      <button
                        onClick={() => handleAddtoCart(product)}
                        className="px-4 py-2.5 bg-black text-white text-sm font-medium rounded-2xl opacity-100 md:opacity-0 md:group-hover:opacity-100 translate-y-0 md:translate-y-4 md:group-hover:translate-y-0 transition-all duration-500 hover:bg-[#D4AF37] hover:text-black"
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      {cartDrawer && (
        //  drawer
        <CartDrawer onClose={() => setCartDrawer(false)} />
      )}
    </section>
  );
};

export default Fragrances;
